import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { DataWidgetComponent } from './data-widget.component';
import { SdkRanking } from '../models/sdkRanking';

@Component({
  template: `<violation-risk
    [label]="label"
    (interact)="openInsight($event)"
  ></violation-risk>`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SdkCodeAnalysisRiskComponent
  extends DataWidgetComponent
  implements OnInit
{
  @Input() data: SdkRanking;

  label: string;

  ngOnInit(): void {
    super.ngOnInit();
    this.label = this.data[this.key];
  }
}
